export default {
  'login.title': 'MyStorageX',
  'login.welcome': 'MyStorageX에 오신 것을 환영합니다',
  'login.description': 'MyStorageX는 안전하고 편리한 파일 저장 및 관리 서비스를 제공하는 클라우드 스토리지 도우미입니다. 언제 어디서나 파일에 접근할 수 있습니다.',
  'login.email.placeholder': '이메일 또는 사용자 이름',
  'login.password.placeholder': '비밀번호',
  'login.button': '로그인',
  'login.loading': '로그인 중...',
  'login.divider': '또는',
  'login.signup': '계정이 없으신가요?',
  'login.signup.link': '회원가입',
  'login.error.default': '로그인에 실패했습니다. 나중에 다시 시도해주세요',
  'login.success': '로그인 성공',
  'login.forgotPassword': '비밀번호를 잊으셨나요?',
  'login.forgotPassword.link': '여기서 재설정',
  'signup.page.title': '회원가입 - MyStorageX',
  'signup.title': 'MyStorageX',
  'signup.welcome': 'MyStorageX에 오신 것을 환영합니다',
  'signup.description': '계정을 만들고 클라우드 스토리지 여정을 시작하세요',
  'signup.username.placeholder': '사용자 이름 입력',
  'signup.email.placeholder': '이메일 입력',
  'signup.password.placeholder': '비밀번호 입력',
  'signup.confirmPassword.placeholder': '비밀번호 확인',
  'signup.button': '가입하기',
  'signup.loading': '가입 중...',
  'signup.login': '이미 계정이 있으신가요?',
  'signup.login.link': '로그인',
  'signup.error.passwordMismatch': '비밀번호가 일치하지 않습니다',
  'signup.error.default': '가입에 실패했습니다. 나중에 다시 시도해주세요',
  'signup.success': '가입이 완료되었습니다',
  'resetPassword.page.title': '비밀번호 재설정 - MyStorageX',
  'resetPassword.page.description': 'MyStorageX 계정 비밀번호 재설정',
  'resetPassword.title': '비밀번호 재설정',
  'resetPassword.email.placeholder': '이메일 주소 입력',
  'resetPassword.code.placeholder': '인증 코드 입력',
  'resetPassword.password.placeholder': '새 비밀번호 입력',
  'resetPassword.button': '비밀번호 재설정',
  'resetPassword.button.loading': '재설정 중...',
  'resetPassword.backToLogin': '로그인으로 돌아가기',
  'resetPassword.sendCode': '인증 코드 받기',
  'resetPassword.sendCode.sending': '전송 중...',
  'resetPassword.sendCode.retry': '{seconds}초 후 재시도',
  'resetPassword.error.emailRequired': '이메일 주소를 입력해주세요',
  'resetPassword.error.codeRequired': '인증 코드를 입력해주세요',
  'resetPassword.error.passwordRequired': '새 비밀번호를 입력해주세요',
  'resetPassword.error.passwordLength': '비밀번호는 6-20자 사이여야 합니다',
  'resetPassword.error.codeLength': '인증 코드는 6자리여야 합니다',
  'resetPassword.success.codeSent': '인증 코드가 이메일로 전송되었습니다',
  'resetPassword.success.reset': '비밀번호가 성공적으로 재설정되었습니다',
  'resetPassword.error.sendFailed': '인증 코드 전송에 실패했습니다. 나중에 다시 시도해주세요',
  'resetPassword.error.resetFailed': '비밀번호 재설정에 실패했습니다. 나중에 다시 시도해주세요',
  'signup.username.rule.length': '사용자 이름은 4-10자여야 합니다',
  'signup.username.rule.format': '문자, 숫자, 밑줄 및 하이픈만 허용됩니다',
  'signup.password.rule.length': '비밀번호는 6-20자여야 합니다',
  'signup.password.rule.lowercase': '소문자를 포함해야 합니다',
  'signup.password.rule.uppercase': '대문자를 포함해야 합니다',
  'signup.password.rule.number': '숫자를 포함해야 합니다',
  'signup.password.rule.special': '특수 문자를 포함해야 합니다',
  'signup.verificationCode.placeholder': '인증 코드를 입력하세요',
  'signup.verificationCode.send': '코드 받기',
  'signup.verificationCode.sending': '전송 중...',
  'signup.verificationCode.retry': '{seconds}초 후 재시도',
  'signup.verificationCode.success': '인증 코드가 전송되었습니다',
  'signup.verificationCode.error': '코드 전송 실패',
  'signup.verificationCode.required': '인증 코드를 입력해 주세요',
  'signup.verificationCode.invalid': '인증 코드 형식이 올바르지 않습니다',
  'signup.error.emailRequired': '이메일 주소를 입력해주세요',
  'signup.announcement': '오늘은 등록 기능이 점검 중입니다!',
  'sidebar.allFiles': '모든 파일',
  'sidebar.starred': '즐겨찾기',
  'sidebar.folders': '폴더',
  'sidebar.trash': '휴지통',
  'sidebar.decrypt': '복호화 도구',
  'sidebar.feedback': '피드백',
  'sidebar.about': '정보',
  'sidebar.productLog': '제품 업데이트',
  'filelist.column.name': '이름',
  'filelist.column.size': '크기',
  'filelist.column.updateTime': '수정일',
  'filelist.column.recycletime': '삭제일',
  'filelist.column.actions': '작업',
  'filelist.total': '총 {total}개 항목',
  'filelist.action.upload': '업로드',
  'filelist.action.newFolder': '새 폴더',
  'filelist.action.refresh': '새로고침',
  'filelist.action.search': '파일 검색',
  'filelist.action.batchDownload': '다운로드',
  'filelist.action.batchDelete': '삭제',
  'filelist.action.download': '다운로드',
  'filelist.action.preview': '미리보기',
  'filelist.action.rename': '이름 변경',
  'filelist.selected': '{count}개 선택됨',
  'filelist.modal.rename.title': '이름 변경',
  'filelist.modal.rename.placeholder': '새 이름 입력',
  'filelist.modal.rename.ok': '확인',
  'filelist.modal.rename.cancel': '취소',
  'page.cloudDrive.title': '내 클라우드 드라이브',
  'page.cloudDrive.description': 'MyStorageX 클라우드 드라이브 - 안전하게 파일을 저장하고 관리하세요',
  'modal.fileUpload.title': '파일 업로드',
  'modal.fileUpload.dragText': '여기에 파일을 끌어다 놓거나 클릭하여 업로드',
  'modal.fileUpload.start': '업로드 시작',
  'modal.fileUpload.cancel': '취소',
  'modal.fileUpload.clear': '목록 지우기',
  'modal.fileUpload.encrypt': '선택한 파일 암호화',
  'modal.fileUpload.addMore': '추가',
  'modal.fileUpload.remove': '제거',
  'modal.fileUpload.duplicate.title': '파일이 이미 존재합니다',
  'modal.fileUpload.duplicate.skip': '건너뛰기',
  'modal.fileUpload.duplicate.replace': '교체',
  'modal.fileUpload.duplicate.rename': '이름 변경',
  'modal.fileUpload.status.pending': '대기 중',
  'modal.fileUpload.status.uploading': '업로드 중',
  'modal.fileUpload.status.success': '완료',
  'modal.fileUpload.status.error': '오류',
  'modal.fileUpload.status.cancelled': '취소됨',
  'modal.fileUpload.status.duplicated': '중복',
  'modal.fileUpload.table.filename': '파일명',
  'modal.fileUpload.table.size': '크기',
  'modal.fileUpload.table.status': '상태',
  'modal.fileUpload.table.progress': '진행률',
  'modal.fileUpload.table.actions': '작업',
  'modal.fileUpload.speed': '업로드 속도',
  'modal.fileUpload.remainingTime': '남은 시간',
  'modal.fileUpload.total.progress': '전체 진행률',
  'modal.fileUpload.error.message': '업로드 실패: {message}',
  'modal.fileUpload.confirm.clear': '업로드 목록을 지우시겠습니까?',
  'modal.fileUpload.confirm.cancel': '업로드를 취소하시겠습니까?',
  'modal.fileUpload.error.noSelection': '제거할 파일을 선택해주세요',
  'modal.fileUpload.error.noEncryption': '암호화할 파일을 선택해주세요',
  'modal.fileUpload.error.noClear': '지울 파일이 없습니다',
  'modal.fileUpload.error.noStart': '업로드할 파일이 없습니다',
  'modal.fileUpload.error.noCancel': '취소할 업로드가 없습니다',
  'modal.fileUpload.error.fileSize': '파일 크기가 제한을 초과했습니다',
  'modal.fileUpload.error.fileType': '지원하지 않는 파일 형식입니다',
  'modal.fileUpload.error.maxCount': '최대 파일 수를 초과했습니다',
  'modal.fileUpload.clear.mobile': '지우기',
  'modal.fileUpload.encrypt.mobile': '암호화',
  'modal.fileUpload.addMore.mobile': '추가',
  'productLog.title': '제품 업데이트',
  // 보안 기능
  'security.features.title': '보안 기능',
  'security.features.localDecryption.title': '로컬 복호화',
  'security.features.localDecryption.description': '모든 복호화 작업은 브라우저에서 로컬로 수행되어 파일 내용과 비밀번호가 장치를 벗어나지 않습니다',
  'security.features.militaryEncryption.title': '군사급 암호화',
  'security.features.militaryEncryption.description': 'AES-256-CBC 암호화 알고리즘 사용. 알려진 모든 공격에 대응할 수 있는 가장 안전한 대칭 암호화 표준입니다',
  'security.features.privacyProtection.title': '개인정보 보호',
  'security.features.privacyProtection.description': '엄격한 개인정보 보호 메커니즘으로 복호화 비밀번호를 저장하지 않고 파일 내용도 기록하지 않습니다',
  'security.features.smartDecryption.title': '스마트 청크 복호화',
  'security.features.smartDecryption.description': '스마트 청크 복호화 기술로 복호화 속도를 크게 향상시키면서 메모리 사용량을 줄입니다',
  'security.features.learnMore': '자세히 알아보기',
  'security.features.modal.title': '보안 기능 상세',
  'security.features.modal.close': '닫기',
  // 보안 팁 모달
  'decrypt.security.modal.title': '보안 알림',
  'decrypt.security.modal.description': '모든 복호화 작업은 로컬에서 수행되며, 비밀번호와 파일 내용이 서버로 전송되지 않습니다',
  'decrypt.security.modal.vip.title': 'VIP 사용자 혜택:',
  'decrypt.security.modal.vip.feature1': '모든 크기의 파일 복호화 가능',
  'decrypt.security.modal.vip.feature2': '스마트 청크 복호화로 효율성 향상',
  'decrypt.security.modal.vip.feature3': '대용량 파일 일괄 복호화 지원',
  'decrypt.security.modal.free.title': '중요: 복호화 과정에는 파일 크기의 약 3배에 해당하는 브라우저 메모리가 필요합니다.',
  'decrypt.security.modal.free.feature1': '무료 사용자는 파일당 4GB 제한',
  'decrypt.security.modal.free.feature2': 'VIP로 업그레이드하여 용량 제한 해제',
  'decrypt.security.modal.free.feature3': '브라우저가 충돌하는 경우 VIP의 청크 복호화 기능 사용을 고려하세요',
  // CBC 암호화 다이어그램
  'security.diagram.plaintext.block1': '평문 블록 1',
  'security.diagram.plaintext.block2': '평문 블록 2',
  'security.diagram.ciphertext.block1': '암호문 블록 1',
  'security.diagram.ciphertext.block2': '암호문 블록 2',
  'security.diagram.key': '키',
  'security.diagram.aes.encryption': 'AES 암호화',
  'security.diagram.xor.operation': 'XOR 연산',
  'security.diagram.iv': '초기화 벡터',
  // Smart Chunk Decryption
  'security.features.chunk.title': '스마트 청크 복호화 기술',
  'security.features.chunk.what': '스마트 청크 복호화란 무엇인가요?',
  'security.features.chunk.description': '스마트 청크 복호화는 대용량 파일을 위해 최적화된 기술로, 파일을 여러 블록으로 나누어 병렬 처리하며 다음과 같은 특징이 있습니다:',
  'security.features.chunk.feature1.title': '동적 분할',
  'security.features.chunk.feature1.desc': '파일 크기와 시스템 메모리를 기반으로 블록 크기를 자동 조정',
  'security.features.chunk.feature2.title': '병렬 처리',
  'security.features.chunk.feature2.desc': '여러 데이터 블록을 동시에 복호화하여 멀티코어 CPU를 최대한 활용',
  'security.features.chunk.feature3.title': '메모리 최적화',
  'security.features.chunk.feature3.desc': '스트리밍 처리를 통해 메모리 사용을 제어하여 오버플로우 방지',
  'security.features.chunk.feature4.title': '재개 지원',
  'security.features.chunk.feature4.desc': '중단 후 계속 진행을 지원하여 오류 허용성 향상',
  'security.features.chunk.how': '작동 방식',
  'security.features.chunk.process': '스마트 청크 복호화 프로세스는 다음 단계를 포함합니다:',
  'security.features.chunk.step1': '파일 분석: 최적의 블록 크기와 수 계산',
  'security.features.chunk.step2': '데이터 분할: 암호화된 파일을 동일한 크기의 블록으로 분할',
  'security.features.chunk.step3': '병렬 복호화: 여러 블록을 동시에 복호화',
  'security.features.chunk.step4': '스트림 쓰기: 복호화된 블록을 순차적으로 기록',
  'security.features.chunk.code': '{code}',
  'security.features.chunk.performance': '성능 이점',
  'security.features.chunk.performance.intro': '전통적인 복호화와 비교하여 스마트 청크 복호화는 다음과 같은 중요한 이점이 있습니다:',
  'security.features.chunk.performance.point1': '메모리 사용량 최대 90% 감소, 4GB 파일에 400MB만 필요',
  'security.features.chunk.performance.point2': '멀티코어 CPU를 활용하여 3-5배 빠른 복호화 속도',
  'security.features.chunk.performance.point3': '대용량 파일(>4GB) 복호화 지원, 브라우저 메모리 제한 없음',
  'security.features.chunk.performance.point4': '정확한 진행 상황과 남은 시간을 보여주는 시각적 복호화 프로세스',
  'security.features.chunk.usage': '사용 사례',
  'security.features.chunk.usage.intro': '스마트 청크 복호화는 다음과 같은 시나리오에 특히 적합합니다:',
  'security.features.chunk.usage.point1': '대용량 파일 복호화(예: 비디오, 데이터베이스 백업)',
  'security.features.chunk.usage.point2': '제한된 메모리 장치에서의 복호화 작업',
  'security.features.chunk.usage.point3': '병렬 처리가 필요한 일괄 복호화',
  'security.features.chunk.usage.point4': '실시간 피드백이 필요한 복호화 작업',
  'security.features.chunk.diagram': '스마트 청크 복호화 프로세스 다이어그램',
  'security.features.aes.security': '보안 특성',
  'security.features.aes.security.intro': 'AES-256-CBC는 다음과 같은 다중 보안 보장을 제공합니다:',
  'security.features.aes.security.point1': '256비트 키는 2^256개의 가능한 조합을 제공하며, 슈퍼컴퓨터로도 무차별 대입 공격이 불가능',
  'security.features.aes.security.point2': 'CBC 모드는 동일한 평문 블록이 서로 다른 암호문 블록을 생성하도록 보장하여 암호화의 무작위성을 증가',
  'security.features.aes.security.point3': '초기화 벡터(IV) 사용으로 동일한 키를 사용하더라도 매번 다른 암호화 결과 보장',
  'security.features.aes.security.point4': '군사, 금융 및 기타 높은 보안이 요구되는 분야에서 널리 사용',
  'security.features.aes.diagram': 'CBC 모드 암호화 프로세스 동적 다이어그램',
  'security.features.aes.why': 'AES-256-CBC를 선택한 이유',
  'security.features.aes.why.intro': '다음과 같은 이유로 AES-256-CBC를 암호화 표준으로 선택했습니다:',
  'security.features.aes.why.point1': '광범위하게 검증된 보안성, 현재까지 실용적인 공격 방법 없음',
  'security.features.aes.why.point2': '우수한 성능, 빠른 암호화 및 복호화',
  'security.features.aes.why.point3': '하드웨어 가속 지원, 현대 프로세서에 AES 명령어 세트 내장',
  'security.features.aes.why.point4': '광범위한 도구 지원, 모든 프로그래밍 언어에서 성숙한 구현',
  'security.features.aes.what': 'AES-256-CBC란 무엇인가요?',
  'security.features.aes.description': 'AES-256-CBC는 고급 암호화 표준(Advanced Encryption Standard)의 구현 방식으로, 다음과 같은 특징이 있습니다:',
  'security.features.aes.detail.1': '2001년 미국 국립표준기술연구소(NIST)에서 제정한 대칭 암호화 알고리즘',
  'security.features.aes.detail.2': '256비트 키 길이를 사용하여 최고 수준의 보안성 제공',
  'security.features.aes.detail.3': '암호 블록 체인(Cipher Block Chaining) 모드로 더 강력한 암호화 보안 제공',
  'security.features.aes.how': '작동 방식',
  'security.features.aes.process': 'AES-256-CBC 암호화 프로세스는 다음 단계를 포함합니다:',
  'security.features.aes.step1': '평문 데이터를 고정 크기 블록(128비트)으로 분할',
  'security.features.aes.step2': '무작위 초기화 벡터(IV) 생성',
  'security.features.aes.step3': 'CBC 모드를 사용하여 이전 암호문 블록과 현재 평문 블록을 XOR 연산',
  'security.features.aes.step4': '256비트 키를 사용하여 XOR 결과에 AES 암호화 수행',
  'security.features.aes.example': '암호화 프로세스 예시:',
  // FileList Section
  'decrypt.fileList.column.name': '파일 이름',
  'decrypt.fileList.column.status': '상태',
  'decrypt.fileList.column.actions': '작업',
  'decrypt.fileList.status.pending': '대기 중',
  'decrypt.fileList.status.decrypting': '복호화 중',
  'decrypt.fileList.status.success': '완료됨',
  'decrypt.fileList.status.error': '오류',
  'decrypt.fileList.action.info': '정보',
  'decrypt.fileList.empty': '복호화할 파일이 없습니다',
  'common.unknown': '알 수 없음',
  'common.speed': '속도',
  'common.timeSpent': '소요 시간',
  'common.remaining': '남은 시간',
  // Upload Section
  'decrypt.upload.dragText': '파일을 클릭하거나 여기로 끌어오세요',
  'decrypt.upload.hint': '.encrypted 파일 일괄 추가 지원, 파일당 최대 {maxSize}',
  'decrypt.upload.button.decrypt': '선택한 파일 복호화',
  'decrypt.upload.button.clear': '목록 지우기',
  // 파일 정보 모달
  'decrypt.fileInfo.modal.title': '파일 정보',
  'decrypt.fileInfo.modal.close': '닫기',
  'decrypt.fileInfo.name': '파일 이름',
  'decrypt.fileInfo.size': '파일 크기',
  'decrypt.fileInfo.type': '파일 유형',
  'decrypt.fileInfo.lastModified': '마지막 수정',
  'decrypt.fileInfo.status': '상태',
  'decrypt.fileInfo.progress': '진행률',
  'decrypt.fileInfo.speed': '속도',
  'decrypt.fileInfo.timeRemaining': '남은 시간',
  'decrypt.fileInfo.timeSpent': '소요 시간',
  'decrypt.fileInfo.error': '오류 메시지',
  'page.decrypt.title': '복호화 도구',
  'page.decrypt.subtitle': '파일을 안전하고 빠르게 복호화',
  'sideMenu.storageInfo.title': '저장 공간',
  'sideMenu.storageInfo.usage': '사용 {used} / 전체 {total}',
  'sideMenu.storageStats.title': '스토리지 통계',
  'sideMenu.storageStats.overview': '개요',
  'sideMenu.storageStats.totalFiles': '총 파일 수',
  'sideMenu.storageStats.totalSize': '총 용량',
  'sideMenu.storageStats.fileTypes': '파일 유형 분포',
  'sideMenu.storageStats.providers': '서비스 제공업체',
  'common.default': '기본값',
  'common.regionCode': '지역 코드',
  'common.nodeType': '노드 유형',
  'common.storageUsed': '사용된 공간',
  'common.storageAvailable': '사용 가능한 공간',
  'common.storageLimit': '총 용량',
  'common.storageUsageDetail': '사용 {used} / 전체 {total}',
  'common.defaultNode': '기본 노드',
  'common.confirm': '확인',
  'common.cancel': '취소',
  'common.latency': '지연 시간',
  'common.retry': '다시 시도',
  'cloudDrive.nodeSelect.title': '스토리지 노드 선택',
  'cloudDrive.nodeSelect.addNode': '스토리지 노드 추가',
  'cloudDrive.nodeSelect.deleteConfirm.title': '노드 삭제 확인',
  'cloudDrive.nodeSelect.deleteConfirm.content': '노드 "{nodeName}"을(를) 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다!',
  'cloudDrive.nodeSelect.deleteSuccess': '노드가 성공적으로 삭제되었습니다',
  'cloudDrive.nodeSelect.deleteFailed': '노드 삭제에 실패했습니다',
  
  // 노드 생성
  'cloudDrive.nodeCreate.title': '스토리지 노드 추가',
  'cloudDrive.nodeCreate.selectProvider': '클라우드 공급자 선택',
  'cloudDrive.nodeCreate.nodeName': '노드 이름',
  'cloudDrive.nodeCreate.nodeNamePlaceholder': '비워두면 기본 이름을 사용합니다',
  'cloudDrive.nodeCreate.nameMaxLength': '노드 이름은 50자를 초과할 수 없습니다',
  'cloudDrive.nodeCreate.noProviders': '사용 가능한 클라우드 공급자가 없습니다',
  'cloudDrive.nodeCreate.pingLatency': '지연 시간 {value} ms',
  'cloudDrive.nodeCreate.pingTesting': '지연 시간 테스트 중...',
  'cloudDrive.nodeCreate.pingFailed': '지연 시간 테스트 실패',
  'cloudDrive.nodeCreate.pingUnavailable': '지연 시간 테스트를 사용할 수 없음',
  'cloudDrive.nodeCreate.sortByLatency': '지연 시간으로 정렬',
  'cloudDrive.nodeCreate.selectRegion': '지역 선택',
  'cloudDrive.nodeCreate.selectedRegion': '선택된 지역',
  'cloudDrive.nodeCreate.noRegions': '사용 가능한 지역이 없습니다',
  'cloudDrive.nodeCreate.selectProviderPlaceholder': '클라우드 공급자를 선택하세요',
  'cloudDrive.nodeCreate.selectProviderRequired': '먼저 클라우드 공급자를 선택하세요',
  'cloudDrive.nodeCreate.selectRegionRequired': '먼저 지역을 선택하세요',
  'cloudDrive.nodeCreate.loadProvidersFailed': '클라우드 공급자 목록 로드 실패',
  'cloudDrive.nodeCreate.loadRegionsFailed': '지역 목록 로드 실패',
  'cloudDrive.nodeCreate.nodeType': '노드 유형',
  'cloudDrive.nodeCreate.nodeType.standard': '표준 스토리지',
  'cloudDrive.nodeCreate.nodeType.lowFreq': '저빈도 스토리지',
  'cloudDrive.nodeCreate.nodeType.archive': '아카이브 스토리지',
  'cloudDrive.nodeCreate.storageLimit': '스토리지 제한',
  'cloudDrive.nodeCreate.storageLimitRequired': '스토리지 제한을 입력하세요',
  'cloudDrive.nodeCreate.storageLimitMin': '스토리지 제한은 1GB보다 작을 수 없습니다',
  'cloudDrive.nodeCreate.storageLimitPlaceholder': '스토리지 제한을 입력하세요 (GB)',
  'cloudDrive.nodeCreate.success': '스토리지 노드가 성공적으로 생성되었습니다',
  'cloudDrive.nodeCreate.failed': '스토리지 노드 생성에 실패했습니다',
  
  // 노드 편집
  'cloudDrive.nodeEdit.title': '노드 편집',
  'cloudDrive.nodeEdit.name': '노드 이름',
  'cloudDrive.nodeEdit.nameRequired': '노드 이름을 입력하세요',
  'cloudDrive.nodeEdit.nameMaxLength': '노드 이름은 50자를 초과할 수 없습니다'
}; 